import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppIdPushCredentialTestCacheKeys: AllRouteEndpoints[] = [];
